import { jt, t } from "ttag";

import { ExternalLink } from "metabase/common/components/ExternalLink";
import { useSelector } from "metabase/redux";
import { CROWDIN_URL } from "metabase/selectors/settings";
import {
  getApplicationName,
  getIsWhiteLabeling,
  getShowMetabaseLinks,
} from "metabase/selectors/whitelabel";

export function getLocalizationNoticeText({
  mentionMetabase,
  applicationName = "RCTECH BI",
}: {
  mentionMetabase: boolean;
  applicationName?: string;
}) {
  return mentionMetabase
    ? t`Some translations are created by the ${applicationName} community, and might not be perfect.`
    : t`Some translations are created by the community, and might not be perfect.`;
}

export interface CommunityLocalizationNoticeProps {
  isAdminView: boolean;
}

export function CommunityLocalizationNotice({
  isAdminView = false,
}: CommunityLocalizationNoticeProps) {
  const showMetabaseLinks = useSelector(getShowMetabaseLinks);
  const isWhiteLabeling = useSelector(getIsWhiteLabeling);
  const applicationName = useSelector(getApplicationName);
  const translatedLink = (
    <ExternalLink
      href={CROWDIN_URL}
      key="crowdin-link"
    >{t`contribute to translations here`}</ExternalLink>
  );

  const showLink = showMetabaseLinks || isAdminView;

  return (
    <span>
      <span>
        {getLocalizationNoticeText({
          mentionMetabase: isAdminView || !isWhiteLabeling,
          applicationName,
        })}
      </span>
      {showLink && <span> {jt`You can ${translatedLink}`}.</span>}
    </span>
  );
}
